export enum BorderSize {
  Sm = '5px',
  Md = '32px',
}
